import React from 'react';
import { CTABand } from '../../components/CTABand';
export function FitnessFinalCTA() {
  return <CTABand headline="Ready to Transform Your Fitness Routine?" copy="Join Storm Taekwondo and discover a workout that builds real skills, confidence, and community. Start your trial class today." data-id="element-1421" />;
}